import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const NetworkApiFailures = (props) => {
    const { message, onClose, t } = props;
    return (
        <div className="popup-modal">
            <div className="modal-cus">
                <div className="popup-box">
                    <h4 className="title">{props.t('network_error')}</h4>
                    <p>{message}</p>
                    <p>{props.t('something_went_wrong_please_try_again')}</p>
                    <div className="d-flex justify-content-center gap-2">
                        {/* <span className="pin-close" onClick={onClose}>{props.t('close')}</span> */}
                        <button className="btn-okay mt-0" onClick={() => window.location.reload()}>{props.t('try_again')}</button>
                    </div>
                </div>

            </div>
        </div>
    );
};

NetworkApiFailures.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(NetworkApiFailures);
